import { ContainerTableHome, TableViewHome } from "../../../components/Table";
import {
  getDexWallet,
  createDexWallet,
} from "../../../services/app";
import { useApp } from "../../../contexts";
import {
  ContainerTableMobileHome,
  InfoTooltipIcon,
  LabelTable,
  LabelTableViewAll,
  TextCellTable,
  UlCustom,
} from "../styles";
import { CellRowImage } from "../../wallet-list/styles";
import { TYPE_WALLET_DETAIL } from "../../../constants";
import { useNavigate } from "react-router-dom";
import {
  DesktopContainer,
  MobileContainer,
} from "../../../components/Container";
import { WalletRowItemSOT } from "./WalletRowItemSOT";
import { ArrowRightIcon } from "../../../components/Icons/ArrowRightIcon";
import React, { useState } from "react";
import { dateFormat, getCoinCodeImage } from "../../../utils/helper";
import { EmptyTable2 } from "../../../components/EmptyTable";
import { Tooltip } from "antd";
import { useWindowSize } from "../../../hook/useWindowSize";
import { error } from "../../../Notification";
import { ModalMintNotify } from "../../../components/ModalMintNotify";
import NumberFormat from "react-number-format";
import {
  decimalSeparatorByCurrency,
  thousandSeparatorByCurrency,
} from "../../../utils/Currency";

export const TableOption = ({ data }) => {
  const { T, formatLocalCurrency, getCurrency } = useApp();
  const [isBtnLoading, $isBtnLoading] = useState(false);
  const [isShowCreateWeb3, setIsShowCreatWeb3] = useState(false);
  const [isShowCreateWeb3Success, setIsShowCreatWeb3Success] = useState(false);
  const navigate = useNavigate();
  const size = useWindowSize();
  const columns = [
    {
      title: T("Opportunity token"),
      dataIndex: "coin",
      key: "coin",
      width: 350,
      sorter: (a, b) => a.coin.toString().localeCompare(b.coin),
      render: (text, record, index) => {
        return (
          <CellRowImage style={{ minWidth: 60 }}>
            <img
              alt=""
              style={{ width: 28, height: 28 }}
              src={`/assets/images/otc/crypto/${getCoinCodeImage(
                text
              )?.toLowerCase()}.svg`}
            />
            <span style={{ marginLeft: 4 }}>{text}</span>
          </CellRowImage>
        );
      },
    },
    {
      title: T("Market Price"),
      dataIndex: "marketPrice",
      key: "marketPrice",
      align: "right",
      width: 180,
      className: "btc-value",
      sorter: (a, b) => a.marketPrice - b.marketPrice,
      render: (text, record, index) => (
        <TextCellTable>{formatLocalCurrency(record.marketPrice)}</TextCellTable>
      ),
    },
    {
      title: T("Amount"),
      dataIndex: "amount",
      key: "amount",
      align: "right",
      width: 300,
      render: (text, record, index) => (
        <TextCellTable>
          <NumberFormat
            value={record.amount}
            displayType={"text"}
            thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
            decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
            decimalScale={8}
          ></NumberFormat>
        </TextCellTable>
      ),
    },
    {
      title: (
        <div className="flex gap-2 justify-end ">
          {T("Est. Converted Value")}
          <Tooltip
            trigger={size.width < 768 ? "click" : "hover"}
            onClick={(e) => e.stopPropagation()}
            className="cursor-pointer"
            color={"#EAF2FF"}
            overlayClassName={"note-tooltip max-w-[500px]"}
            title={
              <UlCustom className="list-disc pl-3">
                <li
                  className="text-start"
                  dangerouslySetInnerHTML={{
                    __html: T(
                      "SOT allows users to purchase $SGT at a fixed price at a time of past after around 14 months from distribution."
                    ),
                  }}
                />
                <li
                  className="text-start"
                  dangerouslySetInnerHTML={{
                    __html: T(
                      "SOT for avatar/subscription purchases will be issued and distributed, and users will be able to claim their SOT to their Web3 wallet when the claimable period arrives."
                    ),
                  }}
                />
                <li
                  className="text-start"
                  dangerouslySetInnerHTML={{
                    __html: T(
                      "SOT alpha is a type of SOT but it can be swapped directly to SGT without exchanging to SOT."
                    ),
                  }}
                />
                <li
                  className="text-start"
                  dangerouslySetInnerHTML={{
                    __html: T("please_visit_for_more"),
                  }}
                />
              </UlCustom>
            }
          >
            <span>
              <InfoTooltipIcon />
            </span>
          </Tooltip>
        </div>
      ),
      dataIndex: "totalValue",
      key: "totalValue",
      className: "Total Value",
      align: "right",
      width: 300,
      render: (text, record, index) => (
        <TextCellTable>{formatLocalCurrency(record.local)}</TextCellTable>
      ),
    },
    {
      title: T("Claimable Amount"),
      dataIndex: "claimableBalance",
      key: "claimableBalance",
      align: "right",
      width: 400,
      render: (text, record, index) => (
        <TextCellTable>
          <NumberFormat
            value={record.claimableBalance}
            displayType={"text"}
            thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
            decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
            decimalScale={8}
          ></NumberFormat>
        </TextCellTable>
      ),
    },
    {
      title: T("Release On"),
      dataIndex: "releaseOn",
      key: "releaseOn",
      align: "right",
      width: 200,
      render: (text, record, index) =>
        record.claimableBalance > 0 ? (
          <div className="flex justify-end relative">
            <button
              type="button"
              className="bg-black text-[14px] top-[-20px] font-semibold absolute rounded-[15px] min-w-[96px] h-[40px]"
              onClick={(e) => {
                e.stopPropagation();
                onClaim(record);
              }}
            >
              <div className="bg-black px-[10px] w-[calc(100%-2px)] flex items-center justify-center mx-[1px] h-[calc(100%-2.2px)] my-[1px] rounded-[15px]">
                <span className="text-white bg-black">{T("Claim")}</span>
              </div>
            </button>
          </div>
        ) : (
          <span className="text-black font-normal">
            {dateFormat(record.releaseTime, "YYYY/MM/DD")}
          </span>
        ),
    },
  ];
  const onClaim = async (item) => {
    try {
      const resultDexWallet = await getDexWallet();
      if (
        resultDexWallet &&
        resultDexWallet.data &&
        resultDexWallet.data.data &&
        resultDexWallet.data.data.public_address
      ) {
        navigate(`/claim-sot?code=${item.currencyCode}`);
      } else {
        setIsShowCreatWeb3(true);
      }
    } catch (e) {
      setIsShowCreatWeb3(true);
    }
  };
  const hanldeCreateWeb3Address = async () => {
    try {
      if (isBtnLoading) return;
      $isBtnLoading(true);
      const createResult = await createDexWallet();
      if (createResult?.data?.error?.status) {
        setIsShowCreatWeb3(false);
        setIsShowCreatWeb3Success(true);
      } else {
        error(T(createResult?.data?.error?.message));
        setIsShowCreatWeb3(false);
      }
    } catch (e) {
      error(T("Create web3 wallet unsuccessfully"));
      setIsShowCreatWeb3(false);
    }
    $isBtnLoading(false);
  };

  const onDetail = (id, record) => {
    navigate(`/wallet-detail/${TYPE_WALLET_DETAIL.OPTION}?code=${record.coin}`);
  };

  const filterData = () => {
    return data;
  };
  const onClickViewAll = () => {
    navigate(`/wallet?type=${TYPE_WALLET_DETAIL.OPTION}`);
  };
  return (
    <div className="wallet-block">
      <div
        className="flex justify-between items-center
        px-[15px] py-[15px] lg:px-[40px] lg:py-[22px] xl:px-[40px] xls:px-[50px] xls:py-[27px] xls:h-[81px]
      "
      >
        <LabelTable className="flex gap-2">
          {T("Opportunity token")}
          <MobileContainer>
            <Tooltip
              trigger={size.width < 768 ? "click" : "hover"}
              onClick={(e) => e.stopPropagation()}
              className="cursor-pointer"
              color={"#EAF2FF"}
              overlayClassName={"note-tooltip max-w-[320px]"}
              title={
                <UlCustom className="list-disc pl-3">
                  <li
                    className="text-start"
                    dangerouslySetInnerHTML={{
                      __html: T(
                        "SOT allows users to purchase $SGT at a fixed price at a time of past after around 14 months from distribution."
                      ),
                    }}
                  />
                  <li
                    className="text-start"
                    dangerouslySetInnerHTML={{
                      __html: T(
                        "SOT for avatar/subscription purchases will be issued and distributed, and users will be able to claim their SOT to their Web3 wallet when the claimable period arrives."
                      ),
                    }}
                  />
                  <li
                    className="text-start"
                    dangerouslySetInnerHTML={{
                      __html: T(
                        "SOT alpha is a type of SOT but it can be swapped directly to SGT without exchanging to SOT."
                      ),
                    }}
                  />
                  <li
                    className="text-start"
                    dangerouslySetInnerHTML={{
                      __html: T("please_visit_for_more"),
                    }}
                  />
                </UlCustom>
              }
            >
              <span>
                <InfoTooltipIcon />
              </span>
            </Tooltip>
          </MobileContainer>
        </LabelTable>
        <LabelTableViewAll
          className="flex items-center gap-1 cursor-pointer"
          onClick={onClickViewAll}
        >
          {T("View all")}
          <ArrowRightIcon color="#818181" />
        </LabelTableViewAll>
      </div>
      <div className="wallet-block-items">
        <DesktopContainer>
          {filterData()?.length ? (
            <ContainerTableHome>
              <TableViewHome
                locale={{
                  emptyText: <EmptyTable2 T={T} />,
                }}
                scroll={{ x: true }}
                tableLayout={"fixed"}
                pagination={false}
                dataSource={filterData()}
                columns={columns}
                isClickRow
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => {
                      onDetail(record.id, record);
                    },
                  };
                }}
              />
            </ContainerTableHome>
          ) : (
            <div className="flex justify-center">
              <EmptyTable2 T={T} />
            </div>
          )}
        </DesktopContainer>
        <MobileContainer>
          {filterData()?.length ? (
            <ContainerTableMobileHome>
              {filterData()?.map((item, index) => (
                <WalletRowItemSOT
                  className={"py-[8px]"}
                  onClick={() => onDetail(item.id, item)}
                  key={index}
                  coin={item.coin}
                  item={item}
                  marketPrice={formatLocalCurrency(item.marketPrice)}
                  onClaim={onClaim}
                  amount={
                    <NumberFormat
                      value={item.amount}
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency(
                        getCurrency()
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        getCurrency()
                      )}
                      decimalScale={8}
                    ></NumberFormat>
                  }
                  local={formatLocalCurrency(item.local)}
                />
              ))}
            </ContainerTableMobileHome>
          ) : (
            <div className="flex justify-center">
              <EmptyTable2 T={T} />
            </div>
          )}
        </MobileContainer>
      </div>
      {isShowCreateWeb3 && (
        <ModalMintNotify
          onClose={() => setIsShowCreatWeb3(false)}
          onSubmit={() => hanldeCreateWeb3Address()}
          isLoading={isBtnLoading}
          title={T("AI Avatar Web3 Wallet not found!")}
          des={T(
            "You need to have a AI Avatar Web3 Wallet to use this function. Please create a AI Avatar Wallet and try again!"
          )}
          buttonText={T("Create Web3 Wallet")}
        />
      )}
      {isShowCreateWeb3Success && (
        <ModalMintNotify
          onClose={() => setIsShowCreatWeb3Success(false)}
          onSubmit={() => onClaim()}
          title={T("Created web3 wallet successfully")}
          des={T(
            "Your web3 wallet has been created successfully. Please access your web3 wallet on AI Avatar app. Now you can convert SOT to SGT using AI Avatar Web3 wallet."
          )}
          buttonText={T("Continue to claim")}
        />
      )}
    </div>
  );
};
